import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import {
    LayoutDashboard,
    Calendar,
    Settings as SettingsIcon,
    LogOut,
    Image,
    Mail,
    BarChart3,
} from 'lucide-react';
import { cn } from '@/lib/utils';

export default function AdminSidebar() {
    const { signOut } = useAuth();
    const location = useLocation();

    const links = [
        { name: 'Tableau de bord', path: '/admin', icon: LayoutDashboard },
        { name: 'Messages', path: '/admin/messages', icon: Mail },
        { name: 'Événements', path: '/admin/events', icon: Calendar },
        { name: 'Galerie', path: '/admin/gallery', icon: Image },
        { name: 'Analytics', path: '/admin/analytics', icon: BarChart3 },
        { name: 'Paramètres', path: '/admin/settings', icon: SettingsIcon },
    ];

    return (
        <aside className="w-64 bg-white border-r border-gray-200 flex flex-col h-screen sticky top-0">
            <div className="p-6 border-b border-gray-100">
                <Link to="/" className="text-2xl font-serif font-bold text-primary-900">
                    UTA <span className="text-accent-500">Admin</span>
                </Link>
            </div>

            <nav className="flex-1 p-4 space-y-2">
                {links.map((link) => {
                    const Icon = link.icon;
                    const isActive =
                        link.path === '/admin'
                            ? location.pathname === '/admin' || location.pathname === '/admin/'
                            : location.pathname === link.path || location.pathname.startsWith(link.path + '/');

                    return (
                        <Link
                            key={link.path}
                            to={link.path}
                            className={cn(
                                "flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors",
                                isActive
                                    ? "bg-primary-50 text-primary-900"
                                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                            )}
                        >
                            <Icon size={20} />
                            {link.name}
                        </Link>
                    );
                })}
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button
                    onClick={signOut}
                    className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg w-full transition-colors"
                >
                    <LogOut size={20} />
                    Déconnexion
                </button>
            </div>
        </aside>
    );
}
